import { getActivitySkills } from "PFCore/helpers/activity_skills";
import { Activity, Weight } from "PFTypes";

export const getRoleSkillsByWeight = (role: Activity, weight: Weight) =>
  getActivitySkills(role).filter((skill) => skill.weight === weight);
